<template>
  <v-app class="print-margin">
    <div v-if="!loader">
      <router-view />
      <div v-if="isTestcafeEnabled()" class="testcafe-bar">Tryb Testcafe</div>
    </div>
  </v-app>
</template>

<script setup lang="ts">
import { isTestcafeEnabled } from '@/services/testCafe'
import { computed } from 'vue'
// @ts-expect-error: Importing Vuex store
import { useStore } from 'vuex'

const store = useStore()

store.dispatch('jsonLangs/getLangs')
const loader = computed(() => store.getters['jsonLangs/getLoader'])
</script>
